import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
/**
 * react-router-domのLinkラッパーコンポーネント。外部リンクの場合はExternalLinkを利用してください
 * @param props
 * @constructor
 */
export const RouterLink = (props) => {
    const { children, className, dataAttributes = {}, onClick, rel: _rel, state, target, to, } = props;
    const rel = target === '_blank' && !_rel ? 'noopener noreferrer' : undefined;
    return (_jsx(Link, Object.assign({}, dataAttributes, { className: clsx(className), onClick: onClick, rel: rel, state: state, target: target, to: to }, { children: children })));
};
